<button mat-icon-button aria-label="Notifications" (click)="onClick($event)" [disabled]="num <= 0" matTooltip="Notifications: {{ num }}">
    <!-- <mat-icon [matBadge]="num"
        matBadgePosition="above after"
        matBadgeSize="medium"
        matBadgeColor="primary" 
        [matBadgeHidden]="num <= 0"
    >
        {{ icon }}
    </mat-icon> -->
    <span
        class="icon-badge-wrapper"
        [matBadge]="num"
        matBadgePosition="above after"
        matBadgeSize="medium"
        [matBadgeColor]="'primary'"
        [matBadgeHidden]="num <= 0"
        aria-label="Notifications indicator"
    >
        <mat-icon aria-hidden="true">
            {{ icon }}
        </mat-icon>
    </span>
    <span class="cdk-visually-hidden">{{ num }}</span>
    <!--<h5 *ngIf="getNum() > 0">{{ getNum() }}</h5>-->
</button>